import React, { useMemo } from 'react';

// import styled from '@emotion/styled';
import { Box, Container, Divider, Grid, Link as MuiLink, Stack, Theme, Typography, useTheme } from '@mui/material';


import Circle from '@mui/icons-material/Circle';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import LinkedIn from '@mui/icons-material/LinkedIn';
import YouTube from '@mui/icons-material/YouTube';
import { Link as GatsbyLink, GatsbyLinkProps, graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import { CardComponent, CardItemProps } from '../../content/component/types/card';
import {LinkList} from "../../../lib/mui/components/linkList";
import {LinkGroupProps} from "../../../lib/mui/components/linkGroup";
import {Link} from "../../../lib/mui/components/link";
import {StrapiContentStatus} from "../../../lib/mui/shared/utils";

const requiredPublishType: StrapiContentStatus = process.env.GATSBY_STRAPI_CONTENT_STATUS

const useStyles = (theme: Theme) => ({
    background: {
        background: '#121212',
        color: 'white',
        pt: { xs: 4, sm: 4, md: 6 },
        pb: { xs: 4, sm: 5, md: 6 },
    },
})

function SocialLink({ platform, url }: { platform: 'Facebook' | 'LinkedIn' | 'YouTube' | 'Instagram', url: string }) {
    let icon: any;
    switch (platform) {
        case 'Facebook':
            icon = <Facebook fontSize='small' />;
            break;
        case 'LinkedIn':
            icon = <LinkedIn fontSize='small' />;
            break;
        case 'YouTube':
            icon = <YouTube fontSize='small' />;
            break;
        case 'Instagram':
            icon = <Instagram fontSize='small' />;
            break;
        default:
            icon = <Circle fontSize='small' />;
    }

    return (
        <Stack direction={"row"} gap={1} sx={{ color: 'inherit' }}>
            {icon}
            <MuiLink href={url} target="_blank" rel="noopener noreferrer" variant='body2' sx={{ color: 'inherit', textDecoration: 'underline' }}>{platform}</MuiLink>
        </Stack>
    )
}

export default function Footer() {
    const theme = useTheme();
    const styles = useStyles(theme)

    const footerDataQuery: Queries.FooterComponentQuery = useStaticQuery(graphql`
    query FooterComponent {
      strapiWebsiteInfo {
        contactEmail: ContactEmail
        contactPhoneText: ContactPhoneText
        contactPhoneE164: ContactPhoneE164
        companyName: CompanyName
        companyAddress: CompanyAddress
        socials: Socials {
          platform: Platform
          url: URL
        }
      }
      strapiFooter {
        logo: Logo {          
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, width: 170, quality: 100)
            }
          }
        }
        content: Content {
            ... on STRAPI__COMPONENT_CONTENT_BLOCKS_CARD {
                id
                Heading
                strapi_component
                Body {
                    type
                    children {
                        text
                        type
                    }
                }
                 Links {
                     id
                     url: URL
                     label: Label
                     buttonType: Type
                     buttonColor: Color
                     hidden: Hidden
                     icon: Icon
                 }
            }
        }
        bottomLinks: BottomLinks {
          url: URL
          label: Label
          hidden: Hidden
        }
      }
      strapiHeader {
        links: Links {
          url: URL
          label: Label
          hidden: Hidden
        }
      }
    }
  `)

    // const NotPrintable = useMemo(() => styled('div')(notPrintable), []);

    const footerProps = useMemo(() => {
        return { ...footerDataQuery.strapiFooter }
    }, [])
    const headerProps = useMemo(() => {
        return { ...footerDataQuery.strapiHeader }
    }, [])

    const websiteInfoProps = useMemo(() => {
        return { ...footerDataQuery.strapiWebsiteInfo }
    }, [])

    const cardSlotProps: CardItemProps['SlotProps'] = useMemo(() => {
        return {
            Container: {
                p: { xs: 0, sm: 0, md: 0 },
                pt: { xs: 0, sm: 0, md: 0 },
                px: { xs: 0, sm: 0, md: 2 },
                py: { xs: 0, sm: 0, md: 0 },
                width: { xs: '100%', sm: '100%', md: 'inherit' },
            },
            ContainerStack: {
                width: { xs: '100%', sm: '100%', md: '100%' },
                // justifyContent: 'space-between',
                // gap: { xs: 5, sm: 2, md: 3 },
                sx: {
                    justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
                    alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
                }
            },
            RootStack: {
                alignItems: 'flex-start',

                justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
            },
            Heading: { color: 'primary', textAlign: 'left', fontSize: '1rem!important', fontWeight: 600 },
            Body: { color: 'white', fontSize: '0.8rem' }
        }
    }, [])

    const logo = footerProps?.logo?.localFile?.childImageSharp?.gatsbyImageData;

    const dividerColor = 'white'

    const thisYear = useMemo(() => new Date().getFullYear(), [])

    // console.log('heree', footerDataQuery.strapiFooter?.content)

    const instaSocial = websiteInfoProps?.socials?.find(s => s && s.platform === 'Instagram')
    const facebookSocial = websiteInfoProps?.socials?.find(s => s && s.platform === 'Facebook')

    return (
        // <NotPrintable>
        <Box component="footer" sx={styles.background}>
            <Container color={'inherit'} sx={{ px: { xs: 0, sm: 2, md: 2, lg: 'initial' }, mx: { xs: 0, sm: 0, md: 'auto', lg: 'auto' } }}>
                <Stack color={'inherit'} direction={"column"} gap={3} justifyContent={'space-between'} sx={{ width: '100%' }} divider={<Divider sx={{ borderColor: dividerColor, width: '100%' }} />}>
                    {/* {headerProps?.links && headerProps?.links.length > 0 && <LinkList
                        links={headerProps?.links as LinkGroupProps[]}
                        requiredPublishType={requiredPublishType}
                        StackProps={{ direction: "row", display: { xs: 'initial', sm: 'initial', md: 'initial', lg: 'none' }, gap: { xs: 0, sm: 0, md: 1, lg: 4 }, justifyContent: { xs: 'space-between', sm: 'center' }, sx: { px: { xs: 2, sm: 0, md: 0 }, width: '100%' } }}
                        // StackProps={{ direction: "row", gap: { md: 1, lg: 2 } }}
                        relativeLinkComponent={GatsbyLink}
                        LinkProps={{ style: { textDecoration: 'none!important', width: '100%', textAlign: 'left' } } as GatsbyLinkProps<any> as any}
                    />} */}
                    <Stack color={'inherit'} direction={{ xs: "column", sm: 'row', md: "row" }} sx={{ width: '100%' }} justifyContent={'space-around'} mb={3} gap={{ xs: 3, sm: 4 }}>
                        {websiteInfoProps.companyName && (
                            <Box sx={{ display: { xs: 'none', sm: 'block', md: 'block' } }}>
                                <GatsbyLink to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <Box sx={{ display: "none" }}>Home</Box>
                                    {logo && <GatsbyImage image={logo} alt="Titan Automotive" loading='lazy' />}
                                </GatsbyLink>
                            </Box>
                        )}

                        <Grid container spacing={{ xs: 7, sm: 4 }} sx={{ width: '100%', pl: { xs: 3, sm: 1, md: 0 } }} columns={{ xs: 2, sm: 3, md: 4, lg: 5, xl: 5 }} justifyContent={{ xs: 'center', sm: 'center', md: 'flex-start', lg: 'space-around' }}>
                            {footerProps && footerProps.content && footerProps.content.length > 0 &&
                                footerProps.content.map((c, i) => c && <Grid size={1} key={i}><CardComponent {...(c as unknown as CardItemProps)} SlotProps={cardSlotProps} Background={'None'} /></Grid>)
                            }

                            {websiteInfoProps.companyName && (
                                <Grid size={1} sx={{ display: { xs: 'block', sm: 'none', md: 'none' } }}>
                                    <GatsbyLink to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Box sx={{ display: "none" }}>Home</Box>
                                        {logo && <GatsbyImage image={logo} alt="Titan Automotive" loading='lazy' />}
                                    </GatsbyLink>
                                </Grid>
                            )}
                            <Grid size={1}>
                                <CardComponent id='socials' Heading='Follow us' SlotProps={cardSlotProps} Background={'None'}>
                                    <Stack direction='column' gap={2} >
                                        <Stack direction='row' gap={2} mt={2}>
                                            {instaSocial && instaSocial.url && (
                                                <MuiLink href={instaSocial.url} underline='none' color='inherit'>
                                                    <StaticImage src='../../../images/instagram.png' alt='Instagram' width={30} height={30} />
                                                </MuiLink>
                                            )}
                                            {facebookSocial && facebookSocial.url && (
                                                <MuiLink href={facebookSocial.url} underline='none' color='inherit'>
                                                    <StaticImage src='../../../images/facebook.png' alt='Facebook' width={30} height={30} />
                                                </MuiLink>
                                            )}
                                        </Stack>
                                        <Stack direction='column' gap={1}>
                                            <Box>
                                                Refrigerant trading authorisation AU18951.
                                            </Box>
                                            <Box>
                                                Approved Inspection Station No 9064.
                                            </Box>
                                        </Stack>
                                    </Stack>
                                </CardComponent>
                            </Grid>
                            <Grid size={1} justifyContent={'flex-start'} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'initial' }, mt: { xs: -1 } }}>
                                <LinkList
                                    links={headerProps?.links as LinkGroupProps[]}
                                    requiredPublishType={requiredPublishType}
                                    StackProps={{ direction: "column", gap: { xs: 0, sm: 0, md: 1, lg: 1 }, justifyContent: { xs: 'space-between', sm: 'center', lg: 'flex-end' }, sx: { px: { xs: 2, sm: 0, md: 0 }, width: '100%' } }}
                                    // StackProps={{ direction: "row", gap: { md: 1, lg: 2 } }}
                                    relativeLinkComponent={GatsbyLink}
                                    LinkProps={{ style: { textDecoration: 'none!important', width: '100%', textAlign: 'left' } } as GatsbyLinkProps<any> as any}
                                />
                            </Grid>
                        </Grid>
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row', md: 'row' }} gap={{ xs: 2, sm: 2, md: 0 }} justifyContent='space-between' alignItems='center' sx={{ width: '100%', pb: { xs:2, sm: 1, md: 0 }}}>
                        <Typography variant="body2" component="div">
                            Copyright &amp; Design <Typography variant="body2" component={'span'} color="primary">{websiteInfoProps.companyName}</Typography> {thisYear}
                        </Typography>
                        <Box>
                            <Typography variant="body2" fontSize='0.8rem' component="div">
                                <Stack divider={<Divider orientation="vertical" flexItem sx={{ borderColor: dividerColor }} />} gap={{ xs: 4, sm: 4, md: 2 }} direction='row'>
                                    {footerProps.bottomLinks && footerProps.bottomLinks.map((link, i) => {
                                        return link && <Link relativeLinkComponent={GatsbyLink} key={i} url={link.url as string} LinkProps={{ fontSize: 'inherit' }} forceLink color='inherit'>{link.label}</Link>
                                    })}
                                </Stack>
                            </Typography>
                        </Box>
                    </Stack>
                </Stack>
            </Container>
        </Box>
        // </NotPrintable>
    )
}
